import type {PinIdentifier} from '../../../types';
import type {PinMapPolygon} from '../../types';

import {Map, Polygon} from '@Map';
import hitArea from 'assets/images/hit-area.svg';
import vendorMarker from 'assets/images/map/pin-vendor.png';
import {FullscreenControl, Marker} from 'react-map-gl/maplibre';

type RegionMapProps = {
  latitude?: number;
  longitude?: number;
  polygons: PinMapPolygon[];
  selectedRegionId?: PinIdentifier;
};

const RegionMap: React.FC<RegionMapProps> = ({latitude, longitude, polygons, selectedRegionId}) => {
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return (
      <div className="mx-3 mt-16 flex h-75 items-center justify-center overflow-hidden rounded-lg bg-gray-02 px-4 text-center">
        <p className="text-body-sm text-gray-07">موقعیت فروشگاه برای نمایش نقشه در دسترس نیست.</p>
      </div>
    );
  }

  const centerLatitude = latitude as number;
  const centerLongitude = longitude as number;

  return (
    <div className="mx-3 mt-16 h-75 overflow-hidden rounded-lg">
      <Map centerLat={centerLatitude} centerLong={centerLongitude} zoom={12}>
        <div className="absolute top-2 right-2 z-10 flex items-center gap-2">
          <div className="flex h-8 items-center justify-center gap-1.5 rounded-md bg-white px-3 text-body-sm-emphasis text-neutral-fg">
            <span
              className="size-4 bg-yellow"
              style={{
                clipPath: 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)'
              }}
              aria-hidden
            />
            منطقه پوشش‌دهی
          </div>
          <div className="flex h-8 items-center justify-center gap-1.5 rounded-md bg-white px-3 text-body-sm-emphasis text-neutral-fg">
            <img className="size-4" src={hitArea} alt="" aria-hidden />
            پین
          </div>
        </div>
        <FullscreenControl position="bottom-left" />
        <Marker longitude={centerLongitude} latitude={centerLatitude}>
          <img className="size-12.5" src={vendorMarker} alt="موقعیت فروشگاه" />
        </Marker>
        {polygons.length > 0 ? (
          <Polygon data={polygons} selectedPolygonId={selectedRegionId} />
        ) : null}
      </Map>
    </div>
  );
};

export default RegionMap;
